/* istanbul ignore file */
import { createStandaloneToast } from '@chakra-ui/react';
import { NotificationStatus } from 'enums/notification-status';

const notification = (
  message: string,
  type = NotificationStatus.ERROR,
  duration: number | null = 6000,
) => {
  const { toast } = createStandaloneToast();
  toast({
    size: 'xs',
    title: message,
    status: type,
    isClosable: true,
    duration,
    containerStyle: {
      color: 'white.base',
    },
  });
};

export default notification;
